/**
 * Payment-related constants
 *
 * SessionStorage keys used for preserving payment state across redirects (e.g., 3DS verification)
 */

/** SessionStorage key for storing the user's cohort (e.g., 'multi-disease') */
export const COHORT_STORAGE_KEY = 'payment_cohort';

/**
 * Positioning variant — controls which value-prop framing the user sees on the
 * payment page. Set via `?positioning=...` URL param; persisted in sessionStorage
 * to survive 3DS/Stripe redirects. Defaults to 'default' when no param is set.
 */
export const POSITIONING_VARIANTS = ['test-before-test', 'checkup', 'default'] as const;
export type PositioningVariant = (typeof POSITIONING_VARIANTS)[number];
export const POSITIONING_VARIANT_STORAGE_KEY = 'positioning_variant';

/**
 * Stripe decline codes commonly returned when HSA/FSA debit cards are
 * rejected due to merchant-category restrictions.
 */
export const HSA_FSA_DECLINE_CODES = new Set([
  'generic_decline',
  'transaction_not_allowed',
  'do_not_honor',
  'invalid_transaction',
  'service_not_allowed',
  'transaction_not_permitted',
]);
